import { SectionMessage } from '@routable/gross-ds';
import React, { useState } from 'react';
import { textHelpers } from 'components/hintTypes/helpers';
import { isPaymentDeliveryOptionSpeedSameOrNextDay } from 'helpers/paymentMethods';
import { useRequestAnimationFrame } from 'hooks';
const PaymentCutoffHint = ({ cutoff, deliveryMethod, isForBulkAction, isPendingApproval, itemCount, speed, title, }) => {
    const getTitle = () => textHelpers.getPaymentCutoffCountdownTitle({
        cutoff,
        deliveryMethod,
        itemCount,
        speed,
        title,
    });
    const [countdownTitle, setCountdownTitle] = useState(getTitle());
    useRequestAnimationFrame(() => {
        if (cutoff) {
            const nextTitle = getTitle();
            setCountdownTitle(nextTitle);
        }
    }, 500);
    if (!cutoff) {
        return null;
    }
    const displayCountdownHint = Boolean(countdownTitle && isPaymentDeliveryOptionSpeedSameOrNextDay(speed));
    if (!displayCountdownHint) {
        return (React.createElement(SectionMessage, { defaultCollapsed: true, intent: "warning", isCollapsible: true, title: textHelpers.getPaymentAfterCutoffTitle({
                deliveryMethod,
                itemCount,
                speed,
                title,
            }) }, textHelpers.getPaymentAfterCutoffBody({
            cutoff,
            deliveryMethod,
            itemCount,
            speed,
            title,
            isPendingApproval,
        })));
    }
    return (React.createElement(SectionMessage, { defaultCollapsed: true, intent: "scheduled", isCollapsible: true, title: countdownTitle }, textHelpers.getPaymentCutoffCountdownBody({
        cutoff,
        deliveryMethod,
        isForBulkAction,
        isPendingApproval,
        itemCount,
        speed,
        title,
    })));
};
export default PaymentCutoffHint;
